/**
 * Returns date of monday in week of given date.
 * @param d
 * @returns {Date}
 */
export function getMonday() {var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
  d = new Date(d);
  var day = d.getDay();
  var diff = d.getDate() - day + (day == 0 ? -6 : 1);
  return new Date(d.setDate(diff));
}


/**
   * Returns index of day in it's week of given date.
   * @param d
   * @returns {number}
   */
export function getDayIndexOfWeek() {var d = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Date.now();
  d = new Date(d);
  var monday = getMonday(d);
  return d.getDate() - monday.getDate();
}


function dayDiff(first, second) {
  return Math.round((second - first) / (1000 * 60 * 60 * 24));
}


export function parseDate(str) {
  var dt = new Date(str);
  var d = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());
  return d;
}


export function getCurrentDay(checkinCreatedAt) {
  var d = new Date();
  var checkinDate = parseDate(checkinCreatedAt);
  return dayDiff(checkinDate, parseDate(d.toISOString())) + 1;
}